import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getToken } from '../../../user/actions/token/GetToken'
import { clearTransaction } from '../../../user/actions/transactions/Clear'
import { sendRawTransaction } from '../../../user/actions/transactions/BuyToken'
import { connect } from 'react-redux'
import lightwallet from 'eth-lightwallet'
import {
  Container,
  Header,
  Segment,
  Button,
  Message,
  Form,
  Modal
} from 'semantic-ui-react'

class BuyToken extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showModal: false,
            checkPassword: '',
            checkConfirmPassword: ''
        }
    }

    componentWillReceiveProps(nextProps){

        let { showHashModal  } = nextProps
  
        if(showHashModal){
 
            this.setState({ showModal: false, checkPassword:'', checkConfirmPassword:''})
        }
    }

    transactionIsDone(){

        let { dispatch, authData } = this.props

        let ks = lightwallet.keystore.deserialize(authData.keystore)
        let address = ks.getAddresses()

        dispatch(clearTransaction())

        dispatch(getToken(address[0]))
    }

    checkPasswordOnInputChange(event) {
        this.setState({ checkPassword: event.target.value})
    }
	
    checkPasswordConfirmOnInputChange(event) {
        this.setState({ checkConfirmPassword: event.target.value})
    }

    checkPasswordSubmitBuy(event) {
        event.preventDefault()

        let { checkPassword, checkConfirmPassword } = this.state

        let { dispatch, authData, buyPrice } = this.props

        let keystore = authData.keystore
       
        dispatch(sendRawTransaction(keystore, buyPrice, checkPassword, checkConfirmPassword))  
    }
    
    render() {

        let { showModal, checkPassword, checkConfirmPassword } = this.state

        let { checkLoading, checkErrorMessage, checkErrorMessageText, showHashModal, transactionHash,
            buyPrice, totalSupply } = this.props

        return(
            <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                <Header as='h1' content='Token' style={{fontSize: '4em',fontWeight: 'normal',marginBottom: '1em',marginTop: '1em'}}/>
                <Container textAlign='left' text>
                    <p>Token gives you the opportunity to solve problems of the city. You can create proposals that will be use the city budget to do what you propose.
                        You can buy only one token. It makes every citizen equal to each other. Also you can sell it if you decided to quit voting community. 
                    </p><p>By token you can: <br/> - create new proposals; <br/> - voting;<br/> - execute proposal after it is passed.<br/>
                    </p><p>For now there are about <strong>{totalSupply}</strong> tokens. The price is <strong>{buyPrice}{/*buyPriceUsd*/}</strong>.</p>
                    <Button.Group size='large'>	
                        <Button positive onClick={() => this.setState({showModal:true})}>Buy Token</Button>
                    </Button.Group> 
                </Container>
                <Modal size='mini'  open={showModal} closeOnEscape={!checkLoading} closeOnRootNodeClick={!checkLoading} onClose={() => this.setState({showModal:false, checkPassword:'', checkConfirmPassword:''})} closeIcon={!checkLoading}>
                    <Modal.Header>
                        Confirm your password
                    </Modal.Header>
                    <Modal.Content>
                        <Message error hidden={!checkErrorMessage} content={checkErrorMessageText}/>
                        <Form size='small' onSubmit={this.checkPasswordSubmitBuy.bind(this)} loading={checkLoading}>
                            <Form.Field>
                                <label>Password</label>
                                <input type='password' minLength='6' autoComplete='new-password' placeholder='Password' value={checkPassword} onChange={this.checkPasswordOnInputChange.bind(this)} />
                            </Form.Field>
                            <Form.Field>
                                <label>Confirm Password</label>
                                <input type='password' minLength='6' autoComplete='current-password' placeholder='Confirm Password' value={checkConfirmPassword} onChange={this.checkPasswordConfirmOnInputChange.bind(this)} />
                            </Form.Field>
                            <Button.Group size='small'>
                                <Button positive type='submit'>Submit</Button>
                            </Button.Group>
                            <p style={{fontSize: '0.7em'}}>* The transaction can take about a minute</p>
                        </Form>
                    </Modal.Content>
                </Modal>
                <Modal basic size='small' open={showHashModal} onClose={() => this.transactionIsDone()} closeIcon>
                    <Header content='Transaction Hash' />
                    <Modal.Content>
                        <p>Transaction successfully processed. <a href={'https://rinkeby.etherscan.io/tx/'+transactionHash} target="_blank">Here</a> you can find all information about it.</p>
                    </Modal.Content>
                </Modal>
            </Segment>
        )	
    }
}

const mapStateToProps = (state) => {
    return {
        totalSupply: state.token.data.totalSupply,
        buyPrice: state.token.data.buyPrice,
        isDeadlineOver: state.proposal.data.isDeadlineOver,
        checkLoading: state.transaction.data.checkLoading,
        checkErrorMessage: state.transaction.data.checkErrorMessage,
        checkErrorMessageText: state.transaction.data.checkErrorMessageText,
        showHashModal: state.transaction.data.showHashModal, 
        transactionHash: state.transaction.data.transactionHash
    }
}

export default connect(mapStateToProps)(BuyToken)

BuyToken.propTypes = {
    buyPrice: PropTypes.string,
    totalSupply: PropTypes.string,
    authData: PropTypes.object,
    dispatch: PropTypes.func,
    checkLoading: PropTypes.bool,
    checkErrorMessage: PropTypes.bool,
    checkErrorMessageText: PropTypes.string,
    showHashModal: PropTypes.bool, 
    transactionHash: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/layouts/token/components/BuyToken.js